import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/skillsewa/r/skillsewa.com-trans/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/skillsewa/r/skillsewa.com-trans/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/pages/admin-dashboard/text-testimonal/TextTestimonal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/ui/separator.tsx");
